import React, { useContext } from 'react';
import { TextLayerExtension } from '@meitu/saas-editor-core/es/editor/layer-extensions/text-layer';
import { isSafari } from '@meitu/saas-editor-core/es/utils/browser-kit';
import { TextAlignType, TextWritingType, type ITextLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { TextAlignmentGroup } from '@/components/text-alignment-group';
import { useEditor } from '@/hooks/use-editor';
import { TextPanelContext } from '../../context';
import { useLayerProps } from '../../hooks';
import { useStore } from '../../store';
import { Tracker } from '../../utils';

export const TextAlignment: React.FC = () => {
    const { layerId, recordId } = useContext(TextPanelContext)!;

    const editor = useEditor();

    const props = useLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as ITextLayerProps;
        const { writingMode, textAlign, shapeExtension } = layerData;

        return {
            writingMode,
            textAlign,
            shapeExtension,
        };
    });
    const shapeExtensionCache = useStore((state) => state.shapeExtensionCache);

    const writingMode = props ? props.writingMode : TextWritingType.HORIZONTAL_TB;
    const textAlign = (() => {
        if (isSafari && props?.textAlign === TextAlignType.JUSTIFY) return TextAlignType.LEFT; // HACK: Safari 下，隐藏 justify 选项，ui 上显示 left
        return props?.textAlign || TextAlignType.CENTER;
    })();
    const shapeExtension = props?.shapeExtension || shapeExtensionCache;

    const disabled = !!shapeExtension;

    const handleChange = (value: TextAlignType) => {
        editor.getInstance(TextLayerExtension).setTextAlign(layerId, value);

        Tracker.setAlignment({
            recordId,
            stageType: editor.stage.getType(),
            writingMode: TextWritingType.HORIZONTAL_TB,
            type: 'textAlign',
            value,
        });
    };

    return (
        <TextAlignmentGroup
            writingMode={writingMode}
            textAlign={textAlign}
            disabled={disabled}
            hideJustify={isSafari}
            onChange={(_, value) => handleChange(value as TextAlignType)}
        />
    );
};
